import api from './base';

async function fetchList() {
  return await api.call('prices/fuelPrice')
}

async function updateAll() {
  return await api.call('prices/fuelPrice/updateAll', {}, 'put')
}

async function updateOne(data) {
  return await api.call('prices/fuelPrice', data, 'put')
}

export default {
  fetchList,
  updateOne,
  updateAll
}



// WEBPACK FOOTER //
// ./app/services/fuel.js